import React, { ForwardedRef, forwardRef, useState } from "react";
import { Badge, Button } from "antd";
import { aiWidgetProps } from "./aiwdiget-interface";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";

const Aiwidget = forwardRef(
  (
    {
      updateShowAIMessageScreen,
      showAIMessageScreen,
      showAIOptions,
      openAIAlert,
      setShowAIOptions,
    }: aiWidgetProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const [showNotifications, setShowNotifications] = useState(false);

    const state = useSelector((state: RootState) => ({
      user: state.user.user,
      aiNotifications: state.app.aiNotifications,
    }));

    const { user, aiNotifications } = state;

    return (
      <div
        className={`custom-box-shadow-three custom-orange-bg-linear-four fixed bottom-[4rem] left-[12rem] z-[1] w-[20rem] p-[1.1rem] pb-0 
        `}
        style={{
          borderRadius: "20px 20px 20px 0px",
          zIndex: showAIOptions ? 1 : 0,
        }}
        ref={ref}
      >
        <p className="text-base font-semibold text-appcolorwhite">
          <b>Hey {user?.firstName}</b>, What do you need help with?
        </p>

        {!showNotifications ? (
          <div className="custom-black-faint rounded-[16px]items-center my-[0.8rem] flex justify-between px-[1.1rem] py-[0.75rem]">
            <div className="flex items-center p-2 rounded-2xl bg-appcolorinnerwhite">
              <img
                src="/img/vectors/stats.svg"
                alt="stats"
                className="h-[2.5rem] w-[2.5rem] cursor-pointer "
              />
            </div>

            <div className="flex items-center p-2 rounded-2xl bg-appcolorinnerwhite">
              <img
                src="/img/vectors/userround.svg"
                alt="userround"
                className="h-[2.5rem] w-[2.5rem] cursor-pointer"
              />
            </div>

            <div className="flex items-center p-2 rounded-2xl bg-appcolorinnerwhite">
              <Badge count={0}>
                <img
                  src="/img/vectors/aimessage.svg"
                  alt="message"
                  className="h-[2rem] w-[2.5rem] cursor-pointer"
                  onClick={() => {
                    updateShowAIMessageScreen(!showAIMessageScreen);
                  }}
                />
              </Badge>
            </div>

            <div className="flex items-center p-2 rounded-2xl bg-appcolorinnerwhite">
              <Badge count={aiNotifications?.length}>
                <img
                  src="/img/vectors/ainotification.svg"
                  alt="notification"
                  className="h-[2rem] w-[2.5rem] cursor-pointer"
                  onClick={() => {
                    setShowNotifications(true);
                  }}
                />
              </Badge>
            </div>
          </div>
        ) : null}

        {showNotifications ? (
          <div className="mb-4">
            <div className="my-[13px] flex items-center rounded-2xl bg-appcolorinnerwhitetwo p-3">
              <img
                src="/img/vectors/whitecaretleft.svg"
                alt="<"
                className="cursor-pointer"
                onClick={() => {
                  setShowNotifications(false);
                }}
              />
              <img
                src="/img/vectors/ainotification.svg"
                alt="notification"
                className="px-[0.3rem]"
              />
              <p className="text-base font-semibold text-appcolorwhite">
                Notifications
              </p>
            </div>

            {aiNotifications.length > 0 ? (
              <div className="relative max-h-[10rem] min-h-[10rem] overflow-y-scroll py-3">
                {aiNotifications.map((item, index) => (
                  <div
                    className="px-3 py-2 mb-4 cursor-pointer rounded-xl bg-appcolorinnerwhitetwo"
                    key={`aiNotifications-${index}`}
                    onClick={() => {
                      openAIAlert(item);
                    }}
                  >
                    <li className="text-appcolorwhite ">{item.title}</li>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-appcolorwhite">
                There are no notifications from {user?.aiTutorDetails?.name} at
                the moment.
              </p>
            )}
          </div>
        ) : null}

        <div className="py-3">
          <Button
            onClick={() => {
              setShowAIOptions(false);
            }}
            style={{
              color: "#200E32 !important",
            }}
            className="custom-white-btn black-text smaller-padding mr-[0.9rem]"
          >
            Close
          </Button>
        </div>
      </div>
    );
  }
);

export default Aiwidget;
